<template>
  <div class="content--sinoreg Relatorios">
    <header-blue>
      SEFAZ/SP: Relação de Óbitos
    </header-blue>

    <div class="px-2 py-3 d-inline-flex align-items-top">
      <div class="col-5 form-group m-0 p-0 mr-2">
        <label for="mes"
               class="label seade_label">Mês</label>
        <select id="mes"
                v-model="form.mes"
                v-validate="'required'"
                name="mes_seade"
                class="custom-select custom-select-sm"
                :class="{'is-invalid': errors.has('mes_seade')}">
          <option :value="null">
            Selecione
          </option>
          <option v-for="(month, index) in meses"
                  :key="index"
                  :value="month.value">
            {{ month.text | firstCapitalize }}
          </option>
        </select>
        <span v-if="errors.has('mes_seade')"
              class="invalid-feedback">
          {{ errors.first('mes_seade') }}
        </span>
      </div>
      <div class="col-5 form-group m-0 p-0">
        <label for="ano"
               class="label">Ano</label>
        <select id="mes"
                v-model="form.ano"
                v-validate="'required'"
                name="ano_seade"
                class="custom-select custom-select-sm"
                :class="{'is-invalid': errors.has('ano_seade')}">
          <option :value="null">
            Selecione
          </option>
          <option v-for="(year, index) in years"
                  :key="index"
                  :value="year">
            {{ year }}
          </option>
        </select>
        <span v-if="errors.has('ano_seade')"
              class="invalid-feedback">
          {{ form.ano ? errors.first('ano_seade') : "Campo obrigatório" }}
        </span>
      </div>
      <div class="pt-3">
        <button class="btn btn-outline-primary btn-sm ml-2 mt-2 px-3"
                @click="listar()">
          Listar
        </button>
      </div>
    </div>
    <hr class="mt-2">
    <div>
      <header-blue v-if="!pdf"
                   class="text-center">
        <small>Selecione mês e ano para visualizar a lista de óbitos nesse período</small>
      </header-blue>

      <object v-if="pdf != null"
              class="document-preview embed-responsive"
              :data="`${ pdf }`"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
      </object>
    </div>
  </div>
</template>

<script>
  /* services */
  import MesAnoService from "@/services/Relatorios/MesAnoService"

  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"

  /* others */
  import moment from "moment"

  export default {
    name: "Sefaz",
    components: {
      HeaderBlue
    },
    data () {
      return {
        pdf: null,
        form: {
          mes: null,
          ano: null
        },
        months: [],
        years: [],
        meses: [
          {text: 'janeiro', value: "01"},
          {text: 'fevereiro', value: "02"},
          {text: 'março', value: "03"},
          {text: 'abril', value: "04"},
          {text: 'maio', value: "05"},
          {text: 'junho', value: "06"},
          {text: 'julho', value: "07"},
          {text: 'agosto', value: "08"},
          {text: 'setembro', value: "09"},
          {text: 'outubro', value: "10"},
          {text: 'novembro', value: "11"},
          {text: 'dezembro', value: "12"},
        ],
      }
    },
    mounted () {
      this.getYears()
    },
    methods: {
      async listar () {
        this.$validator.validate().then(async status => {
          if (status) {
            const payload = {
              tipo_registro: 'O', // deixando óbito mockado por enquanto
              tipo_relatorio: 'SEFAZ',
              mes: this.form.mes,
              ano: this.form.ano
            }

            try {
              loader({ active: true })
              this.pdf = await MesAnoService.getPdf(payload)
            } finally {
              loader({ active: false })
            }
          }
        })
      },
      getYears () {
        const year = moment().year()

        for (let ano = year; ano >= 1900; ano--) {
          this.years.push(ano)
        }
      }
    }
  }
</script>

<style scoped>
  .document-preview {
    height: 500px !important;
  }
</style>
